type AdminPageSkeletonVariant = 'dashboard' | 'manageAppointment'

const SkeletonBlock = ({ className }: { className: string }) => (
  <div className={`animate-pulse rounded bg-muted ${className}`} />
)

export function AdminPageSkeleton({ variant }: { variant: AdminPageSkeletonVariant }) {
  return (
    <div className='space-y-6'>
      <div className='bg-white px-6 py-6 sm:px-8'>
        <div className='space-y-4'>
          <SkeletonBlock className='h-4 w-32' />
          <div className='space-y-2'>
            <SkeletonBlock className='h-7 w-56' />
            <SkeletonBlock className='h-4 w-64' />
          </div>
          {variant === 'manageAppointment' && (
            <div className='flex flex-wrap gap-2'>
              <SkeletonBlock className='h-6 w-20' />
              <SkeletonBlock className='h-6 w-24' />
            </div>
          )}
        </div>
      </div>
      <div className='bg-white px-6 py-6 sm:px-8'>
        {variant === 'dashboard' ? (
          <div className='space-y-4'>
            <div className='grid grid-cols-1 gap-4 md:grid-cols-3'>
              {[1, 2, 3].map((i) => (
                <SkeletonBlock key={i} className='h-10' />
              ))}
            </div>
            <SkeletonBlock className='h-10' />
            <SkeletonBlock className='h-72' />
          </div>
        ) : (
          <div className='grid grid-cols-1 gap-6 lg:grid-cols-12'>
            <div className='space-y-4 lg:col-span-4'>
              <SkeletonBlock className='h-40' />
              <SkeletonBlock className='h-36' />
            </div>
            <div className='space-y-4 lg:col-span-4'>
              <SkeletonBlock className='h-44' />
              <SkeletonBlock className='h-44' />
            </div>
            <div className='space-y-4 lg:col-span-4'>
              <SkeletonBlock className='h-96' />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
